export const pageTitle = (title) => {
  return (document.title = title + " - Mode Marketing & Consultancy Agency");
}